module.exports = __webpack_public_path__ + "img/RCT05.fa143dcf.svg";